import React from 'react'
import Link from 'gatsby-link'
import {isDomElement} from '../../util'

import Search from '../Search/search'
import LanguageSelector from '../LanguageSelector/language-selector'

import './header.scss'
import Logo from '../../assets/logo'
import ArrowRightIcon from '../../assets/icons/arrow-right-icon'
import MenuIcon from '../../assets/icons/menu-icon'
import CloseIcon from '../../assets/icons/close-icon'


class Header extends React.Component {
  state = {
    showHamburgerMenu: false
  }

  header = React.createRef()

  closeHamburgerMenu = this.closeHamburgerMenu.bind(this)
  toggleHamburgerMenu = this.toggleHamburgerMenu.bind(this)
  
  toggleHamburgerMenu() {
    if (!this.state.showHamburgerMenu) {
      document.body.addEventListener('click', this.closeHamburgerMenu)
    }    

    this.setState(prevState => ({showHamburgerMenu: !prevState.showHamburgerMenu}))
  }

  closeHamburgerMenu(event) {
    if (!isDomElement(event.target, this.header.current)) {
      document.body.removeEventListener('click', this.closeHamburgerMenu)

      this.setState({
        showHamburgerMenu: false
      })
    }
  }

  render() {
    const { localization, searchLocation } = this.props

    const children = React.Children.map(this.props.children, child =>
      React.cloneElement(child, { linkClicked: () => this.setState({ showHamburgerMenu: false }) })
    );

    // Show or hide Header 'Apply Here' button
    const showApplyBtn = this.props.applyButton ? this.props.applyButton.showApplyBtn : false
    const applyBtn = this.props.applyButton && this.props.applyButton.cta ? this.props.applyButton.cta : null

    return (
      <nav className="header-container" data-cy="header">
        <div className="header-left-wrapper">
          <Link className="header-logo unstyled" to={ `/${this.props.lang}` } title="Home">
            <Logo/>
          </Link>
        </div>
        <div
          ref={ this.header }
          className={"header-main " + (this.state.showHamburgerMenu ? 'show-hamburger-menu'  : 'hide-hamburger-menu')}>
          { children }
        

          { showApplyBtn && applyBtn && applyBtn.title && applyBtn.url ? <a href={applyBtn.url} target="_blank" rel="noopener" className="unstyled header-apply-container header-apply-mobile">
            <span>{applyBtn.title}</span>
            <ArrowRightIcon className="header-apply-arrow"/>
          </a> : null }
        </div>
        <div className="header-actions">
          <Search lang={this.props.lang} location={searchLocation} localization={ localization }/>
          <div 
            className={"header-hamburger-container " + (this.state.showHamburgerMenu ? 'bg-pink' : '')}
            onClick={ this.toggleHamburgerMenu }>
            {this.state.showHamburgerMenu ? <CloseIcon className="hamburger-close-icon" /> : <MenuIcon className="header-hamburger"/>}
          </div>
          { showApplyBtn && applyBtn && applyBtn.title && applyBtn.url ? <a href={applyBtn.url} target="_blank" rel="noopener" className="unstyled header-apply-container header-apply-desktop">
            <span>{applyBtn.title}</span>
            <ArrowRightIcon className="header-apply-arrow"/>
          </a> : null }
        </div>
      </nav>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/header.js